/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpRespSidebarBlurbs_displayInfo$ref = any;
export type PdpRespSidebarBlurbs_displayInfo = {
    readonly pricing: {
        readonly showSold: boolean | null;
        readonly showUnavailable: boolean | null;
    } | null;
    readonly " $refType": PdpRespSidebarBlurbs_displayInfo$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespSidebarBlurbs_displayInfo",
    "type": "ItemDisplayInfo",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "pricing",
            "storageKey": null,
            "args": null,
            "concreteType": "PriceInfoDisplay",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "showSold",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "showUnavailable",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '2fdc3c9f176989c6082300b0d9cb6b4d';
export default node;
